import { render, staticRenderFns } from "./appTestimony.vue?vue&type=template&id=6660d738"
import script from "./appTestimony.vue?vue&type=script&lang=js"
export * from "./appTestimony.vue?vue&type=script&lang=js"
import style0 from "./appTestimony.vue?vue&type=style&index=0&id=6660d738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports